import axiosInstance from '@client/utils/axios.util';
import { logger } from '@client/utils/logger.util';

import type { IPricingRule } from '@common/types';

export const getEntitlementOperations = async (): Promise<IPricingRule[]> => {
  try {
    const { data } = await axiosInstance.get<IPricingRule[]>(
      '/entitlements/operations',
    );
    return data;
  } catch (error) {
    logger.error('getEntitlementOperations', error);
    throw error;
  }
};
